
export const PAGE_CONFIG = {
  "name": "reportTabs",
  "config": {
    "tabList": [
      {
        "pageType": "datalab",
        "id": "45411456361f32ab5adb304629adf2b1",
        "nameEn": "By Cohort Analysis",
        "nameCn": "By Cohort Analysis",
        "logConfig": {
          "pageId": "103101",
          "pageName": "By Cohort Analysis",
          "pagePath": "/multiReports/cbt"
        }
      },
      {
        "pageType": "datalab",
        "id": "968c41024f3789d50df6da2bc8304dba",
        "nameEn": "By Class Analysis",
        "nameCn": "By Class Analysis",
        "logConfig": {
          "pageId": "103102",
          "pageName": "By Class Analysis",
          "pagePath": "/multiReports/cbt"
        }
      },
      {
        "pageType": "outPath",
        "id": "/dashboard/game/poe2/funnel/registerFunnelDaily",
        "nameEn": "Progression Funnel",
        "nameCn": "关卡漏斗",
        "logConfig": {
          "pageId": "",
          "pageName": "Progression Funnel",
          "pagePath": "/multiReports/cbt"
        }
      },
      {
        "pageType": "outPath",
        "id": "/dashboard/game/poe2/comparisonAnalysis/eventComparison",
        "nameEn": "Event Comparison",
        "nameCn": "事件对比",
        "logConfig": {
          "pageId": "",
          "pageName": "Event Comparison",
          "pagePath": "/multiReports/cbt"
        }
      }
    ]
  }
};